import React from 'react';
import classNames from 'classnames';
import styles from './DrawerFooter.module.scss';

export interface DrawerFooterProps {
	className?: string;
	children?: React.ReactNode;
	hasNoPadding?: boolean;
}

export const DrawerFooter: React.FunctionComponent<DrawerFooterProps> = ({ className, children, hasNoPadding }) => {
	return (
		<footer className={classNames(!hasNoPadding && classNames(styles.footer, 'u-container-lg'), className)}>
			{children}
		</footer>
	);
};
